const AuditLogTypes = {
  FETCH_AUDIT_LOG_START: 'FETCH_AUDIT_LOG_START',
  FETCH_AUDIT_LOG_SUCCESS: 'FETCH_AUDIT_LOG_SUCCESS',
  FETCH_AUDIT_LOG_FAILURE: 'FETCH_AUDIT_LOG_FAILURE'
};

export default AuditLogTypes;